<template>
  <div class="dashboard-container">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="250px" class="sidebar">
        <div class="logo">
          <h3>设备管理系统</h3>
        </div>
        
        <el-menu
          :default-active="$route.path"
          class="sidebar-menu"
          router
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
          <el-menu-item index="/dashboard/devices">
            <el-icon><Monitor /></el-icon>
            <span>设备管理</span>
          </el-menu-item>
          
          <el-menu-item 
            v-if="isAdmin" 
            index="/dashboard/users"
          >
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </el-menu-item>
          
          <el-menu-item 
            v-if="isAdmin" 
            index="/dashboard/accessories"
          >
            <el-icon><Tools /></el-icon>
            <span>配件管理</span>
          </el-menu-item>
          
          <el-menu-item 
            v-if="isAdmin" 
            index="/dashboard/borrow-requests"
          >
            <el-icon><Document /></el-icon>
            <span>借用申请管理</span>
          </el-menu-item>
          
          <el-menu-item 
            v-if="isAdmin" 
            index="/dashboard/field-config"
          >
            <el-icon><Setting /></el-icon>
            <span>字段配置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <!-- 主内容区 -->
      <el-container>
        <!-- 顶部导航 -->
        <el-header class="header">
          <div class="header-left">
            <span class="welcome-text">欢迎，{{ currentUser?.username }}</span>
          </div>
          
          <div class="header-right">
            <el-dropdown @command="handleCommand">
              <span class="user-dropdown">
                <el-icon><Avatar /></el-icon>
                {{ currentUser?.username }}
                <el-icon class="el-icon--right"><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="logout">
                    <el-icon><SwitchButton /></el-icon>
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        
        <!-- 主要内容 -->
        <el-main class="main-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { mapGetters } from 'vuex'
import { Monitor, User, Avatar, ArrowDown, Setting, Document, Tools } from '@element-plus/icons-vue'

export default {
  name: 'DashboardView',
  components: {
    Monitor,
    User,
    Avatar,
    ArrowDown,
    Setting,
    Document,
    Tools
  },
  computed: {
    ...mapGetters(['currentUser', 'isAdmin'])
  },
  methods: {
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await ElMessageBox.confirm(
            '确定要退出登录吗？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
          
          this.$store.dispatch('logout')
          ElMessage.success('已退出登录')
          this.$router.push('/login')
        } catch {
          // 用户取消
        }
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  overflow: hidden;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b3a4b;
  color: white;
  border-bottom: 1px solid #1f2d3d;
}

.logo h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.sidebar-menu {
  border: none;
  height: calc(100vh - 60px);
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}

.header-left .welcome-text {
  color: #666;
  font-size: 14px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.user-dropdown .el-icon {
  margin: 0 5px;
}

.main-content {
  background-color: #f5f5f5;
  padding: 20px;
  overflow-y: auto;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}
</style>